// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__ZQeIZ","slide":"Slider_slide__yxseg"};